import React from "react";

const About = () => {
  return (
    <div className="about-us container">
      <p className="about-us-title">MoshiMoshiMall - Situs Jual Beli Barang Jepang Online di Indonesia</p>
      <p className="about-us-desc">MoshiMoshiMall merupakan situs jual beli online di Indonesia yang memiliki jutaan toko online dan menjual berbagai macam produk untuk memenuhi kebutuhan Anda. Belanja online terasa semakin mudah dan menyenangkan saat ini karena apapun yang Anda inginkan pasti bisa ditemukan di MoshiMoshiMall. Cek barang kesukaanmu, belanja kado terindah untuk si dia, beli berbagai kebutuhan rumah tangga, beli gadget terbaru yang sedang tren, belanja pakaian yang sudah kamu idamkan, sampai dengan bayar tagihan listrik setiap bulan, semua bisa kamu lakukan hanya dengan sekali klik.</p>
      <p className="about-us-link">Baca Selengkapnya</p>
    </div>
  );
};

export default About;
